import { Card, Row, Select } from "antd";
import { useMemo, useState } from "react";
import { IOption } from "../../../types/Option";
import { Loader } from "./Loader";

type PAmountsCardProps = {
  title: string;
  options: IOption[];
  isLoading: boolean;
  paymnentAmounts: any[] | null;
};

export const AmountsCard = ({
  title,
  options,
  isLoading,
  paymnentAmounts,
}: PAmountsCardProps) => {
  const [selected, setSelected] = useState<number>(1);

  const amount = useMemo(() => {
    if (paymnentAmounts) {
      return paymnentAmounts.find((item: any) => item.label === selected).value;
    }

    return "";
  }, [selected, paymnentAmounts]);

  return (
    <Card className="dashboard-card payments mt-4">
      {!isLoading ? (
        <>
          <Row className="justify-space-between mb-2">
            <p className="my-0 text">{title}</p>
            <Select
              value={selected}
              disabled={isLoading}
              options={options}
              size="small"
              onChange={setSelected}
              dropdownMatchSelectWidth={false}
            />
          </Row>
          <h3 className="my-0 h h3">{amount.toLocaleString()}</h3>
        </>
      ) : (
        <Loader />
      )}
    </Card>
  );
};
